import React, { useState, useEffect } from 'react';
import { Bell } from 'lucide-react';
import { base44 } from '@/api/base44Client';
import { useQuery } from '@tanstack/react-query';
import { Button } from '@/components/ui/button';
import NotificationCenter from './NotificationCenter';

export default function NotificationBell({ user }) {
  const [showCenter, setShowCenter] = useState(false);

  const { data: notifications = [], refetch } = useQuery({
    queryKey: ['notifications', user?.id],
    queryFn: () => base44.entities.Notification.filter({ user_id: user?.id }, '-created_date', 50),
    enabled: !!user?.id,
    refetchInterval: 30000, // Refetch every 30 seconds
  });

  const unreadCount = notifications.filter(n => !n.read).length;

  return (
    <>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setShowCenter(true)}
        className="relative rounded-xl"
      >
        <Bell className="w-5 h-5 text-gray-600" />
        {unreadCount > 0 && (
          <span className="absolute -top-1 -right-1 w-5 h-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center font-semibold">
            {unreadCount > 9 ? '9+' : unreadCount}
          </span>
        )}
      </Button>

      {showCenter && (
        <NotificationCenter
          notifications={notifications}
          onClose={() => {
            setShowCenter(false);
            refetch();
          }}
          user={user}
        />
      )}
    </>
  );
}